import React, {useEffect} from "react";
import S360WidgetBlock from "root/s360components/LearningJournal/S360WidgetBlock";
import BootstrapCol from "root/ReactHookForm/ui/BootstrapCol";
import {FormInputDatePicker} from "root/ReactHookForm/FormComponents";
import BootstrapRow from "root/ReactHookForm/ui/BootstrapRow";
import {LunchReportFormSections} from "root/s360components/LunchReport/LunchReportPage";
import {isAfter} from "date-fns";


export const LunchReportsDateRangeLimits = {
    START: 'start_date',
    END: 'end_date'
}

export const lunchReportDateRangeDefaults = () =>
{
    return {
        [LunchReportFormSections.DATES]:
            {
                [LunchReportsDateRangeLimits.START]: new Date(),
                [LunchReportsDateRangeLimits.END]: new Date()
            }
    }
}

const HookSubFormCustomDateRange = ({control, resetField, getValues, formErrors, sectionName, readOnly}) =>
{

    return (
        <S360WidgetBlock title=''>
            <BootstrapRow>
                <BootstrapCol width={6} style={{marginTop: '5px', marginBottom: '5px'}}>
                    <FormInputDatePicker readOnly={readOnly} label='Pick a start date' sectionName={sectionName}
                                         name={LunchReportsDateRangeLimits.START} control={control} required={true}
                                         formErrors={formErrors}/>
                </BootstrapCol>
                <BootstrapCol width={6} style={{marginTop: '5px', marginBottom: '5px'}}>
                    <FormInputDatePicker readOnly={readOnly} label='Pick an end date' sectionName={sectionName}
                                         name={LunchReportsDateRangeLimits.END} control={control} required={true}
                                         formErrors={formErrors}/>
                </BootstrapCol>
            </BootstrapRow>
        </S360WidgetBlock>
    )
}

export default HookSubFormCustomDateRange;